export default __webpack_public_path__ + "static/media/ic-tv.b24b9510.svg";